import client from '@/graphql/client'
import ListChatLog from '@/graphql/queries/ListChatLog'
import ClearChatLog from '@/graphql/mutations/ClearChatLog'
import CreateChatLog from '@/graphql/mutations/CreateChatLog'
import OnCreateChatLog from '@/graphql/subscriptions/OnCreateChatLog'
import { addToSubscriptions } from '@/api/subscriptionHelpers'

export const chatLog = {
  namespaced: true,
  state: {
    chatLog: [],
    subscriptions: null,
    suppressIncoming: false
  },
  mutations: {
    setChatLog (state, payload) {
      state.chatLog = payload
    },
    setSubscriptions (state, payload) {
      state.subscriptions = payload
    },
    setSuppressIncoming (state, payload) {
      state.suppressIncoming = !!payload
    },
    unsubscribeFromAll (state) {
      if (state.subscriptions) {
        for (const subscription of state.subscriptions) {
          subscription.unsubscribe()
        }
      }
      state.subscriptions = null
    },
    addChatLog (state, payload) {
      if (state.suppressIncoming) {
        return
      }
      const index = state.chatLog.findIndex((log) => log.id === payload.id)
      if (index === -1) {
        state.chatLog.unshift(payload)
      }
    }
  },
  actions: {
    async createChatLog ({ commit }, { projectId, input, silent = false }) {
      try {
        const data = await client.query({
          operationName: 'createChatLog',
          query: CreateChatLog,
          variables: { projectId, input }
        })

        if (!silent) {
          commit('addChatLog', data.createChatLog)
        }
        return data.createChatLog
      } catch (e) {
        console.log(e)
      }
    },

    async listChatLog ({ commit }, { workflowId }) {
      try {
        let allItems = []
        let nextToken = null

        do {
          const res = await client.query({
            operationName: 'listChatLog',
            query: ListChatLog,
            variables: { workflowId, limit: 100, nextToken }
          })
          const data = res?.listChatLog
          allItems = allItems.concat(data?.items || [])
          nextToken = data?.nextToken
        } while (nextToken)

        commit('setChatLog', allItems)

        // Unsubscribe from previous subscriptions before creating new ones
        commit('unsubscribeFromAll')

        const subscriptions = []
        const addSubscription = (query, variables, callback) => {
          const sub = addToSubscriptions(query, variables, callback)
          subscriptions.push(sub)
        }

        addSubscription(OnCreateChatLog, { workflowId }, (data) => {
          commit('addChatLog', data.onCreateChatLog)
        })

        commit('setSubscriptions', subscriptions)

        return allItems
      } catch (e) {
        console.log(e)
      }
    },

    async clearChatLog ({ commit }, { projectId, workflowId, silent = false }) {
      try {
        const data = await client.query({
          operationName: 'clearChatLog',
          query: ClearChatLog,
          variables: { projectId, workflowId }
        })

        if (data?.clearChatLog) {
          if (!silent) {
            commit('setChatLog', [])
            commit('snackbar/showMessage', { content: 'Chat history has been cleared!' }, { root: true })
          }
          return data.clearChatLog
        }
      } catch (e) {
        console.log(e)
        commit('snackbar/showMessage', {
          content: e?.message || 'Failed to clear history',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    }
  }
}
